import api from './api';
import { Task, UpdateTaskDTO, CreateTaskDTO } from '../types/task';

export const taskService = {
  createTask: async (taskData: CreateTaskDTO) => {
    const response = await api.post<Task>('/api/v1/tasks', taskData);
    return response.data;
  },

  getMyTasks: async (params?: any) => {
    console.log('Calling API to get my tasks...', params);
    try {
      const response = await api.get<Task[]>('/api/v1/tasks', { params });
      console.log('My tasks API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error getting my tasks:', error);
      throw error;
    }
  },

  getAvailableTasks: async (params?: any) => {
    console.log('Calling API to get available tasks...', params);
    try {
      const response = await api.get<Task[]>('/api/v1/tasks/available', { params });
      console.log('Available tasks API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error getting available tasks:', error);
      throw error;
    }
  },

  getTaskById: async (taskId: number) => {
    console.log(`Calling API to get task by ID: ${taskId}...`);
    try {
      const response = await api.get<Task>(`/api/v1/tasks/${taskId}`);
      console.log('Task by ID API response:', response);
      return response.data;
    } catch (error) {
      console.error(`Error getting task by ID ${taskId}:`, error);
      throw error;
    }
  },

  updateTask: async (taskId: number, taskData: UpdateTaskDTO) => {
    const response = await api.put<Task>(`/api/v1/tasks/${taskId}`, taskData);
    return response.data;
  },

  completeTask: async (taskId: number) => {
    const response = await api.post<Task>(`/api/v1/tasks/${taskId}/complete`);
    return response.data;
  },

  deleteTask: async (taskId: number) => {
    const response = await api.delete<Task>(`/api/v1/tasks/${taskId}`);
    return response.data;
  },

  getFavoriteTasks: async (params?: any) => {
    const response = await api.get<Task[]>('/api/v1/tasks/favorites', { params });
    return response.data;
  },

  toggleTaskFavorite: async (taskId: number) => {
    const response = await api.post<{ task_id: number; is_favorited: boolean; professional_favorites: number | null }>(
      `/api/v1/tasks/${taskId}/favorite`
    );
    return response.data;
  }
}; 